import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { NbBreadcrumb } from "../components/NbBreadcrumb";
import { NbExplainer } from "../components/NbExplainer";
import { NumberBaseTool } from "../components/NumberBaseTool";

export function NumberBasePage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <NbBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.nb_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.nb_intro()}
          </p>
        </header>

        <NumberBaseTool />

        <NbExplainer
          howTo={m.nb_howto()}
          faqs={[
            { q: m.nb_faq1_q(), a: m.nb_faq1_a() },
            { q: m.nb_faq2_q(), a: m.nb_faq2_a() },
            { q: m.nb_faq3_q(), a: m.nb_faq3_a() },
            { q: m.nb_faq4_q(), a: m.nb_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
